import { useCallback, useLayoutEffect, useRef, type Dispatch } from 'react'

function useSafeDispatch<A>(dispatch: Dispatch<A>) {
    const mounted = useRef<boolean>(false)

    useLayoutEffect(() => {
        mounted.current = true
        return () => {
            mounted.current = false
        }
    }, [])

    return useCallback(
        (action: A) => (mounted.current ? dispatch(action) : void 0),
        [dispatch],
    ) as Dispatch<A>
}

export { useSafeDispatch }
